export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFE0CC',
  },
  INACTIVE: {
    Title: 'Inactive',
    Color: '#cff5d1',
  },
};
